<template>
  <div>
    <v-dialog
      max-width="550px"
      max-height="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Asset Category
          <v-spacer></v-spacer>
          <v-text-field
            dense
            hide-details
            v-model="search"
            append-icon="mdi-magnify"
            label="Search subcategory"
            class="mr-2"
          ></v-text-field>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row justify="center">
          <v-col cols="12" md="6" lg="6">
              <h3 style="text-align:center">Category Name</h3>
              <v-text-field
                v-model="currentCategory.Dev_Skills_Category_Description"
                :readonly="!editMode"
                :rules="[rules.englishOnly]"
                ></v-text-field>
            </v-col>
          </v-row>
          <div class="mx-3">
            <h2 class="mb-4" style="text-align:start">Subcategories</h2>
            <v-divider></v-divider>
            <v-data-table
              dense
              fixed-header
              :headers="headers"
              :items="employeeSkillsSubcategories"
              :search="search"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 20, 50, -1]
              }"
            >
              <template v-slot:[`item.Dev_Skills_Subcategory_Description`]="{ item, index }">
                <v-text-field
                  v-if="editSubcategoryMode === index"
                  v-model="item.Dev_Skills_Subcategory_Description"
                  :rules="[rules.englishOnly]"
                  hide-details="auto"
                  dense
                ></v-text-field>
                  <span v-else>{{ item.Dev_Skills_Subcategory_Description }}</span>
              </template>
              <template v-slot:[`item.Can_Delete`]="{ item, index }">
                <v-btn
                  icon
                  small
                  :disabled="addNewMode || (editSubcategoryMode > -1 && editSubcategoryMode !== index) || (editSubcategoryMode === index && /[а-яА-ЯЁёҐґЄєІіЇї]/.test(item.Dev_Skills_Subcategory_Description))"
                  :color="editSubcategoryMode === index ? 'success' : 'primary'"
                  @click.prevent="updateSubcategory(index, item)"
                >
                  <v-icon>{{editSubcategoryMode === index ? 'mdi-check-circle' : 'mdi-pencil-circle'}}</v-icon>
                </v-btn>
                <v-btn
                  v-if="editSubcategoryMode === index"
                  icon
                  small
                  color="primary"
                  @click.prevent="cancelSubcategoryEditing(index, item)"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  color="red darken-2"
                  :disabled="addNewMode || (editSubcategoryMode > -1 && editSubcategoryMode !== index)"
                  v-if="editSubcategoryMode !== index"
                  @click.prevent="openDeleteSubcategoryDialog(index, item)"
                >
                  <v-icon>mdi-delete-circle</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`body.append`]>
                <tr v-if="editMode" :class="addNewMode ? 'elevation-0' : ''">
                  <td class="px-2">
                    <v-text-field
                      v-if="addNewMode"
                      v-model="subCategoryItem.Dev_Skills_Subcategory_Description"
                      :rules="[rules.englishOnly]"
                      hide-details="auto"
                      dense
                      label="Add new subcategory"
                      class="mt-1 mb-1"
                      dark
                    ></v-text-field>
                  </td>
                  <td class="text-center text-no-wrap">
                    <v-btn
                      v-if="!addNewMode"
                      :disabled="editSubcategoryMode > -1"
                      small
                      icon
                      color="success"
                      @click.prevent="addNewMode = true"
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                    <template v-else>
                      <v-btn
                        :disabled="!subCategoryItem.Dev_Skills_Subcategory_Description || /[а-яА-ЯЁёҐґЄєІіЇї]/.test(subCategoryItem.Dev_Skills_Subcategory_Description)"
                        small
                        icon
                        color="success"
                        @click.prevent="addNewSubcategoryToggle"
                      >
                        <v-icon>mdi-check-circle</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        icon
                        color="primary"
                        @click.prevent="addNewMode = false"
                      >
                        <v-icon>mdi-close-circle</v-icon>
                      </v-btn>
                    </template>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            @click.prevent="saveCategory"
            :disabled="editMode && (/[а-яА-ЯЁёҐґЄєІіЇї]/.test(currentCategory.Dev_Skills_Category_Description))"
          > {{editMode ? 'Save' : 'Edit'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteSubcategoryDialog"
      v-model="deleteSubcategoryDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      :message="deleteSubcategoryMessage"
      @onDeleteClick="confirmDeleteSubcategory"
      @onCancelClick="closeDeleteSubcategoryDialog"
      @onCloseClick="closeDeleteSubcategoryDialog"
    />
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'EmployeeSkillsEditor',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      required: false
    },
    currentCategory: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    },
    employeeSkillsSubcategories: {
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      search: '',
      editMode: false,
      editSubcategoryMode: -1,
      addNewMode: false,
      subCategoryItem: {
        Dev_Skills_Subcategory_ID: null,
        Dev_Skills_Category_ID: null,
        Dev_Skills_Subcategory_Description: ''
      },
      deleteSubcategoryDialog: false,
      subcategoryToDelete: null,
      rules: {
        englishOnly: value => {
          if (!value) return true
          return !/[а-яА-ЯЁёҐґЄєІіЇї]/.test(value) || 'English only'
        }
      }
    }
  },
  computed: {
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    deleteSubcategoryMessage () {
      if (!this.subcategoryToDelete || !this.subcategoryToDelete.item) return ''
      return this.subcategoryToDelete.item.Can_Delete === false
        ? 'This skill has employee data. Delete the skill and all related data?'
        : 'Delete this skill?'
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.editMode = false
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    headers () {
      const res = [
        {
          text: 'Subcategory Name',
          value: 'Dev_Skills_Subcategory_Description',
          divider: true,
          class: 'px-2 text-no-wrap'
        }
      ]
      if (this.editMode) {
        res.push({
          text: '#',
          align: 'center',
          value: 'Can_Delete',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '20%'
        })
      }
      return res
    }
  },
  mounted () {
  },
  methods: {
    saveCategory () {
      if (this.addMode && this.editMode) {
        const body = {
          Dev_Skills_Category_Description: this.currentCategory.Dev_Skills_Category_Description,
          Subcategories: this.employeeSkillsSubcategories
        }
        this.axios.post('/api/employee_skills/category', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('setSuccess', { successMsg: 'New category successfully added' })
          this.show = false
          this.editMode = false
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else if (this.editMode) {
        const body = {
          Dev_Skills_Category_ID: this.currentCategory.Dev_Skills_Category_ID,
          Dev_Skills_Category_Description: this.currentCategory.Dev_Skills_Category_Description
        }
        this.axios.put(`/api/employee_skills/category/${this.currentCategory.Dev_Skills_Category_ID}`, body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('setSuccess', { successMsg: 'Current category successfully updated' })
          this.show = false
          this.editMode = false
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else {
        this.editMode = true
      }
    },
    addNewSubcategoryToggle () {
      if (this.addNewMode && !this.addMode) {
        this.subCategoryItem.Dev_Skills_Category_ID = this.currentCategory.Dev_Skills_Category_ID
        this.axios.post('/api/employee_skills_subcategory', this.subCategoryItem, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.subCategoryItem.Dev_Skills_Subcategory_ID = res.data[0].Dev_Skills_Subcategory_ID
          this.$store.dispatch('setSuccess', { successMsg: 'Subcategory successfully added' })
          const newSubcategory = {
            Dev_Skills_Subcategory_ID: this.subCategoryItem.Dev_Skills_Subcategory_ID,
            Dev_Skills_Category_ID: this.subCategoryItem.Dev_Skills_Category_ID,
            Dev_Skills_Subcategory_Description: this.subCategoryItem.Dev_Skills_Subcategory_Description
          }
          this.employeeSkillsSubcategories.push(newSubcategory)
          this.clearSubcategoryItem()
          this.addNewMode = false
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else if (this.addNewMode && this.addMode) {
        const subcategory = {
          Dev_Skills_Subcategory_ID: null,
          Dev_Skills_Category_ID: null,
          Dev_Skills_Subcategory_Description: this.subCategoryItem.Dev_Skills_Subcategory_Description
        }
        this.employeeSkillsSubcategories.push(subcategory)
        this.clearSubcategoryItem()
        this.addNewMode = false
      } else {
        this.clearSubcategoryItem()
        this.addNewMode = true
      }
    },
    clearSubcategoryItem () {
      this.subCategoryItem.Dev_Skills_Subcategory_ID = null
      this.subCategoryItem.Dev_Skills_Category_ID = null
      this.subCategoryItem.Dev_Skills_Subcategory_Description = ''
    },
    updateSubcategory (index, item) {
      if (this.editSubcategoryMode > -1) {
        const body = {
          Dev_Skills_Subcategory_ID: item.Dev_Skills_Subcategory_ID,
          Dev_Skills_Category_ID: this.currentCategory.Dev_Skills_Category_ID,
          Dev_Skills_Subcategory_Description: item.Dev_Skills_Subcategory_Description
        }
        this.axios.put(`/api/employee_skills/subcategory/${body.Dev_Skills_Subcategory_ID}`, body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          for (let i = 0; i < this.employeeSkillsSubcategories.length; i++) {
            if (this.employeeSkillsSubcategories[i].Dev_Skills_Subcategory_ID === item.Dev_Skills_Subcategory_ID) {
              this.employeeSkillsSubcategories[i] = res.data[0]
              break
            }
          }
          this.$store.dispatch('setSuccess', { successMsg: 'Subcategory successfully updated' })
          this.editSubcategoryMode = -1
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else {
        this.subCategoryItem.Dev_Skills_Subcategory_Description = item.Dev_Skills_Subcategory_Description
        this.editSubcategoryMode = index
      }
    },
    cancelSubcategoryEditing (index, item) {
      item.Dev_Skills_Subcategory_Description = this.subCategoryItem.Dev_Skills_Subcategory_Description
      this.editSubcategoryMode = -1
    },
    openDeleteSubcategoryDialog (index, item) {
      this.subcategoryToDelete = { index, item }
      this.deleteSubcategoryDialog = true
    },
    closeDeleteSubcategoryDialog () {
      this.deleteSubcategoryDialog = false
      this.subcategoryToDelete = null
    },
    confirmDeleteSubcategory () {
      if (!this.subcategoryToDelete) return
      const { index, item } = this.subcategoryToDelete
      if (this.addMode) {
        this.employeeSkillsSubcategories.splice(index, 1)
        this.closeDeleteSubcategoryDialog()
        return
      }
      this.axios.delete(`/api/employee_skills/subcategory/${item.Dev_Skills_Subcategory_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeeSkillsSubcategories.splice(index, 1)
        this.$store.dispatch('setSuccess', { successMsg: 'Subcategory successfully deleted' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }).finally(() => {
        this.closeDeleteSubcategoryDialog()
      })
    }
  }
}
</script>
